import { isEmpty } from 'lodash';

export function isSignedIn(state) {
  return !isEmpty(state.user);
}

export function currentUser(state) {
  return state.user;
}

export function currentUserId(state) {
  return state.user.id;
}

export function isPublisherUser(state) {
  if (!isEmpty(state.user) && !isEmpty(state.user.publisher)) {
    return true;
  }

  return false;
}

export function isBusanPublisher(state) {
  return !isEmpty(state.user) && state.user.id === 'busanedu';
}

export function currentUserContryCode(state, getters) {
  return getters.currentUser.country_code || 'KR';
}

export function isKrUser(state, getters) {
  return getters.currentUserContryCode === 'KR';
}

export function currentPublisherInfo(state, getters) {
  if (getters.isPublisherUser) {
    return state.user.publisher;
  }

  return {};
}

export function getIsDevice(state) {
  return !isEmpty(state.device);
}



// WEBPACK FOOTER //
// ./src/app/auth/store/getters.js